import { applyMiddleware, createStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import { CookieStorage } from "redux-persist-cookie-storage";
import Cookies from "js-cookie";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./rootReducer";
import { getEnvironmentVariables } from "../common/utils";

import logger from "./middleware/core/logger";
import api from "./middleware/core/api";
import routeManager from "./middleware/core/routeManager";
import toaster from "./middleware/core/toaster";
// import { sampleOrchestrator } from "./middleware/apiOrchestrators/sampleOrchestrator";

// The access slice holds the user's granted-claim verdicts, which WithAuth
// refetches on every screen load. Persisting them would serve stale verdicts
// across sessions and bloat the cookie sent with every request, so they are
// stripped before the entities state is written out.
const dropAccessSlice = createTransform(
  (entities) => ({ ...entities, access: undefined }),
  null,
  { whitelist: ["entities"] }
);

const persistConfig = {
  key: "root",
  storage: new CookieStorage(Cookies, {
    setCookieOptions: {
      domain: getEnvironmentVariables().REACT_APP_HOST,
    },
  }),
  transforms: [dropAccessSlice],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middleware = applyMiddleware(
  // sampleOrchestrator, // <- uncomment if you use it
  ...getDefaultMiddleware({
    serializableCheck: false,
  }),
  logger({ destination: "console" }),
  toaster(),
  api,
  routeManager()
);

const store = createStore(persistedReducer, composeWithDevTools(middleware));

const persistor = persistStore(store);

// ✅ Export as named exports
export { store, persistor };
